import { useDispatch, useSelector } from "react-redux";

import { useGetTranslatedEnumResourceCodeGetter } from "../../hooks/useGetTranslatedEnumResourceCodeGetter";
import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";
import { EnumName } from "../../utils/enums";
import { Checkbox } from "../Checkbox";

type Options = number[] | string[];

export interface OptionsListFilterProps extends ColumnFilterProps {
  optionsSelectorValue: (state: RootState) => Options;
  enumName?: EnumName;
}

export const OptionsListFilter: React.FC<OptionsListFilterProps> = ({
  enumName,
  fieldName,
  optionsSelectorValue,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const dispatch = useDispatch();
  const options = useSelector(optionsSelectorValue);
  const value = [
    ...((useSelector((state: RootState) => filterSelectorValue(state, fieldName))?.value as Options) ?? []),
  ];

  const { getTranslatedEnumResourceCode } = useGetTranslatedEnumResourceCodeGetter();

  return (
    <>
      {options.map((option) => (
        <div key={option}>
          <Checkbox
            checked={value.includes(option)}
            onChange={() => {
              if (!value.includes(option)) {
                value.push(option);
              } else {
                value.splice(value.indexOf(option), 1);
              }

              dispatch(
                filterUpdateAction({ id: fieldName, name: fieldName, operator: FilterOperator.IsAnyOf, value: value })
              );
            }}
          />
          {enumName ? getTranslatedEnumResourceCode(enumName, option) : option}
        </div>
      ))}
    </>
  );
};
